<div class="launch-container">
  <div class="filter-container">
    <button
      type="button"
      class="filter-fab"
      [class.filter-fab--hidden]="open()"
      (click)="open.set(true)"
      aria-label="Filtry"
      aria-haspopup="dialog"
    >
      <svg
        viewBox="0 0 24 24"
        class="filter-fab__icon"
        focusable="false"
        aria-hidden="true"
      >
        <path d="M3 6h18M7 11h10M10 16h4" />
      </svg>
    </button>

    <app-category-filter
      [name]="'Aukcje produktowe'"
      [data]="filterDataForFocusedView()"
      [open]="open()"
      (toggled)="open.set($event)"
      (selected)="filterAuctions($event.id)"
    >
    </app-category-filter>
  </div>

  @if (auctions().length > 0) {
  <div class="viewport" (scroll)="onScroll($event)">
    @for (auction of auctions(); track auction.id) {
    <div class="filtered-auction cursor-pointer" (click)="goToAuction(auction)">
      @if (auction.firstItem) {
      <div class="filtered-auction-item">
        <div class="filtered-auction-item-logo">
          <img
            loading="lazy"
            [src]="auction?.firstItem?.product?.brandLogoUrl ?? ''"
            [alt]="auction?.firstItem?.product?.brandName"
          />
        </div>
        <div class="filtered-auction-item-image">
          <img
            loading="lazy"
            [src]="auction?.firstItem?.product?.images?.[0]?.url ?? ''"
            [alt]="auction?.firstItem?.product?.name"
          />
        </div>
        <p class="product-name">
          {{ auction?.firstItem?.product?.name }}
        </p>
      </div>
      } @if (auction.state === 'ongoing') {
      <div class="filtered-timer">
        <app-filtered-auction-timer
          [secondsLeft]="auction.timeLeft"
          [startTimerFlag]="true"
        ></app-filtered-auction-timer>
      </div>
      } @if (auction.state === 'scheduled') {
      <div style="margin-left: 4px; margin-right: 4px">
        <p class="m-0 filtered-auction-start-at start-at">
          Aukcja zacznie się za:
        </p>

        <div class="timer">
          @for (unit of timeUnitsFor(auction); track $index) {
          <div class="time-box">
            <div class="flip-card">
              <div class="time-value">{{ unit.value }}</div>
            </div>
            <div class="time-label">{{ unit.label }}</div>
          </div>
          }
        </div>
      </div>

      } @if (auction.secondItem) {
      <div class="filtered-auction-item">
        <div class="filtered-auction-item-logo">
          <img
            loading="lazy"
            [src]="auction?.secondItem?.product?.brandLogoUrl ?? ''"
            [alt]="auction?.secondItem?.product?.brandName"
          />
        </div>
        <div class="filtered-auction-item-image">
          <img
            loading="lazy"
            [src]="auction?.secondItem?.product?.images?.[0]?.url ?? ''"
            [alt]="auction?.secondItem?.product?.name"
          />
        </div>
        <p class="product-name">
          {{ auction?.secondItem?.product?.name }}
        </p>
      </div>
      }
    </div>
    }
  </div>

  } @else {
  <div class="empty">
    <p class="m-0">Brak wyników.</p>
  </div>
  }
</div>
